import { api } from '../api/api';

export const getEmailCount = async () => {
  return await api()
    .post('https://lawyer.ijro.uz/api/chat/getUnreadMessagesCount', {})
    .then((res) => {
      return res;
    })
    .catch((e) => {
      console.log(e);
    });
};
